import Vue from 'vue'
// 删除数组中的指定值
  function removeByValue(arr,val) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] == val) {
        arr.splice(i, 1);
        break;
      }
    }
  }
// 获取地址栏中参数的值
  function getPara(paraName) {
    console.log(paraName)
    var surl = location.href;
    var reg = "(?:\\?|&){1}"+paraName+"=([^&]*)";
    var re = new RegExp(reg,'gi');
    re.exec(surl);
    return RegExp.$1;
  }
// 修改日期格式
  function dateFormat(val,mark){
    return val.substr(0,4) + mark + val.substr(4,2) + mark + val.substr(6,2);
  }

//修改指定日期改为时间戳
  function formatDate(date){
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    if (m < 10){
      m = '0'+m;
    }
    if (d < 10){
      d = '0'+d;
    }
    return y+'-'+m+'-'+d;
  }

// 获取当前日期
  function curDate(val) {
    var date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = '';
    if(val == -1){
      d = date.getDate()-1;
    } else {
      d = date.getDate();
    }
    if (m < 10){
      m = '0'+m;
    }
    if (d < 10){
      d = '0'+d;
    }
    if(val == 1 || val == -1){
      return y+''+m+''+d;
    } else {
      return y+'-'+m+'-'+d;
    }
  }

  function GMTToStr(time){
    let date = new Date(time)
    let Str=date.getFullYear() + '-' +
    (date.getMonth() + 1) + '-' +
    date.getDate() + ' ' +
    date.getHours() + ':' +
    date.getMinutes() + ':' +
    date.getSeconds()
    return Str
  }

//  function date2Str(val) {
    let date2Str = (dt, fmt)=>
    {
      const placeHolders = [
        [(x, y)=>y.replace('%Y', x.getFullYear()), '%Y'],
        [(x, y)=>y.replace('%m', String(x.getMonth() + 1)), '%m'],
        [(x, y)=>y.replace('%d', String(x.getDate())), '%d'],
        [(x, y)=>y.replace('%H', String(x.getHours())), '%H'],
        [(x, y)=>y.replace('%M', String(x.getMinutes())), '%M'],
        [(x, y)=>y.replace('%S', String(x.getSeconds())), '%S'],
        [(x, y)=>y.replace('%s', String(x.getTime())), '%s'],
      ];
      const ph = placeHolders;
      for (var f of placeHolders)
      {
        let formatter = f[0];
        fmt = formatter(dt, fmt);
      }
      return fmt;
    }
//  }

//  function str2Date(val){
    const str2Date = (str, fmt) =>
    {
      const placeHolders = [
        [(x, y)=>x.setYear(y), '%Y', '(\\d{2,4})'],
        [(x, y)=>x.setMonth(y - 1), '%m', '(\\d{1,2})'],
        [(x, y)=>x.setDate(y), '%d', '(\\d{1,2})'],
        [(x, y)=>x.setHours(y), '%H', '(\\d{1,2})'],
        [(x, y)=>x.setMinutes(y), '%M', '(\\d{1,2})'],
        [(x, y)=>x.setSeconds(y), '%S', '(\\d{1,2})'],
        [(x, y)=>x.setTime(y), '%s', '(\\d+)'],
      ];
      const ph = placeHolders;
      const phIndex = ph.map(x => [x[0], fmt.search(x[1]), x[2], x[1]])
                .filter(x => x[1] != -1)
                .sort((x, y)=> x[1] >y[1]);
      const patternStr = phIndex.reduce((x, y)=> x.replace(y[3], y[2]), fmt);
      const pattern = new RegExp(patternStr);
      const m = pattern.exec(str);
      var d = new Date(0);
      for (var p in phIndex)
      {
        var setter = phIndex[p][0];
        var groupIndex = Number(p) + 1;
        setter(d, Number(m[groupIndex]));
      }
      return d;
    }
//  }

//  计算某个日期之前或者之后的日期
function getOtherDate(date,interval){
  let expireDate = new Date(date);
  expireDate.setDate(expireDate.getDate() + interval);
  return expireDate.getFullYear()+"-"+(expireDate.getMonth()+1)+"-"+expireDate.getDate();
}

// 比较两个日期的大小
function compareDate(date1,date2){
  console.log(date1,date2);
  if(date1){
    var d1 = new Date(date1.replace(/\-/g,"\/"));
  }
  if(date2){
    var d2 = new Date(date2.replace(/\-/g,"\/"));
  }
  return d1>=d2;
}

// 根据id获取对应下拉菜单的选项
  var selectVal =  GLOBAL.selectOption;
  function getSelect(flag,id){
    if (selectVal[flag]){
      for(var i=0; i<selectVal[flag].options.length; i++){
        if (selectVal[flag].options[i].id == id){
          return selectVal[flag].options[i].text;
        }
      }
    }
  }
// 将一级数组转换为三级数组
  function resetData(item){
    var dataList = [];
    // 添加isCheck参数，判断分类是否选中
    for(var z=0; z<item.length; z++){
      item[z]['isCheck'] = 0;
    }
    var data = item;
    // 获取一级诊断分类
    for(var i=0; i<data.length; i++){
      if(data[i].parentid == 0){
        dataList.push(data[i]);
      }
    }
    // 获取二级诊断分类
    for(var k=0; k<dataList.length; k++){
      dataList[k]['child'] = [];
      for(var j=0; j<data.length; j++){
        if (data[j].parentid == dataList[k].id){
          dataList[k]['child'].push(data[j]);
        }
      }
    }
    // 获取三级诊断分类
    for(var x=0; x<dataList.length; x++){
      for(var y=0; y<dataList[x]['child'].length; y++){
        dataList[x]['child'][y]['child'] = [];
        for (var l=0; l<data.length; l++){
          if (data[l].parentid == dataList[x]['child'][y].id){
            dataList[x]['child'][y]['child'].push(data[l]);
          }
        }
      }
    }
    return dataList;
  }

  // 将三级分类中的每一个对象都加一个check字段
  function addCheck(item){
    for(var i=0; i<item.length; i++){
      item[i]['isCheck'] = false;
      if(item[i]['child']){
        for(var j=0; j<item[i]['child'].length; j++){
          item[i]['child'][j]['isCheck'] = false;
          if(item[i]['child'][j]['child']){
            for(var k=0; k<item[i]['child'][j]['child'].length; k++){
              item[i]['child'][j]['child'][k]['isCheck'] = false;
            }
          }
        }
        // 使用递归函数会导致选中不起作用，原因待查
        //addCheck(item[i]['child']);
      } else {
        break;
      }
    }
    return item;
  }

  // 判断对象是否存在于指定数组中
  function contains(arr, obj) {
    var i = arr.length;
    while (i--) {
      if (arr[i] === obj) {
        return true;
      }
    }
    return false;
  }

// 倒序排序对象
  function reverseObj(obj) {
    var arr = [];
    for (var i in obj) {
      arr.push([obj[i],i]);
    }
    arr.reverse();
    var len = arr.length;
    var objs = {};
    for (var j = 0; j < len; j++) {
      objs[arr[j][1]] = arr[j][0];
    }
    return objs;
  }
  //所有游戏转化成树状结构,这个树状结构还是有问题，之后会调整
  function getAllGames(trainList,trainClass){
      var Games = {};
      /* 全部游戏 */
      Games["label"] = "全部游戏";
      Games["name"] = "allGames";
      Games["pid"] = 0;
      Games["parent"] = null;
      Games["oneGrade"] = {};
      Games["oneGrade"]["all"] = {};
      Games["children"] = {};
      Games["oneGrade"]["all"]["id"] = 0;
      Games["oneGrade"]["all"]["name"] = "全部";
      Games["oneGrade"]["all"]["pid"] = 0;
      Games["oneGrade"]["all"]["games"] = [];

      /* 认知游戏 */
      Games["children"]["cogn"] = {};
      Games["children"]["cogn"]["label"] = "认知游戏";
      Games["children"]["cogn"]["name"] = "cognGames";
      Games["children"]["cogn"]["pid"] = 10;
      Games["children"]["cogn"]["parent"] = "allGames";
      Games["children"]["cogn"]["oneGrade"] = {};
      Games["children"]["cogn"]["children"] = {};
      Games["children"]["cogn"]["oneGrade"]["all"] = {};
      Games["children"]["cogn"]["oneGrade"]["all"]["id"] = 0;
      Games["children"]["cogn"]["oneGrade"]["all"]["name"] = "全部";
      Games["children"]["cogn"]["oneGrade"]["all"]["pid"] = 0;
      Games["children"]["cogn"]["oneGrade"]["all"]["games"] = [];

      /* 言语游戏 */
      Games["children"]["lan"] = {};
      Games["children"]["lan"]["label"] = "言语游戏";
      Games["children"]["lan"]["name"] = "lanGames";
      Games["children"]["lan"]["pid"] = 11;
      Games["children"]["lan"]["parent"] = "allGames";
      Games["children"]["lan"]["oneGrade"] = {};
      Games["children"]["lan"]["children"] = {};
      Games["children"]["lan"]["oneGrade"]["all"] = {};
      Games["children"]["lan"]["oneGrade"]["all"]["id"] = 0;
      Games["children"]["lan"]["oneGrade"]["all"]["name"] = "全部";
      Games["children"]["lan"]["oneGrade"]["all"]["pid"] = 0;
      Games["children"]["lan"]["oneGrade"]["all"]["games"] = [];

      /* 情绪与社会认知 */
      Games["children"]["men"] = {};
      Games["children"]["men"]["label"] = "情绪与社会认知游戏";
      Games["children"]["men"]["name"] = "menGames";
      Games["children"]["men"]["pid"] = 12;
      Games["children"]["men"]["parent"] = "allGames";
      Games["children"]["men"]["oneGrade"] = {};
      Games["children"]["men"]["children"] = {};
      Games["children"]["men"]["oneGrade"]["all"] = {};
      Games["children"]["men"]["oneGrade"]["all"]["id"] = 0;
      Games["children"]["men"]["oneGrade"]["all"]["name"] = "全部";
      Games["children"]["men"]["oneGrade"]["all"]["pid"] = 0;
      Games["children"]["men"]["oneGrade"]["all"]["games"] = [];

      
      trainClass.forEach((item)=>{
        /* 全部游戏下的一级脑能力 */
        Games["oneGrade"][item.name] = {};
        Games["oneGrade"][item.name]["name"] = item.name;
        Games["oneGrade"][item.name]["id"] = item.id;
        Games["oneGrade"][item.name]["pid"] = item.pid;
        Games["oneGrade"][item.name]["games"] = [];

        /* 认知游戏下的一级脑能力 */
        if(item.pid == Games["children"]["cogn"]["pid"]){
          Games["children"]["cogn"]["oneGrade"][item.name] = {};
          Games["children"]["cogn"]["oneGrade"][item.name]["name"] = item.name;
          Games["children"]["cogn"]["oneGrade"][item.name]["id"] = item.id;
          Games["children"]["cogn"]["oneGrade"][item.name]["pid"] = item.pid;
          Games["children"]["cogn"]["oneGrade"][item.name]["games"] = [];
          Games["children"]["cogn"]["children"][item.name]= {};
          Games["children"]["cogn"]["children"][item.name]["label"]= item.name + "_game";
          Games["children"]["cogn"]["children"][item.name]["name"]= item.name;
          Games["children"]["cogn"]["children"][item.name]["pid"]= item.id;
          Games["children"]["cogn"]["children"][item.name]["parent"]= "cognGames";
          Games["children"]["cogn"]["children"][item.name]["oneGrade"]= [];
          Games["children"]["cogn"]["children"][item.name]["children"]= {};
        }

        /* 言语游戏下的一级脑能力 */
        if(item.pid == Games["children"]["lan"]["pid"]){
          Games["children"]["lan"]["oneGrade"][item.name] = {};
          Games["children"]["lan"]["oneGrade"][item.name]["name"] = item.name;
          Games["children"]["lan"]["oneGrade"][item.name]["id"] = item.id;
          Games["children"]["lan"]["oneGrade"][item.name]["pid"] = item.pid;
          Games["children"]["lan"]["oneGrade"][item.name]["games"] = [];
          Games["children"]["lan"]["children"][item.name]= {};
          Games["children"]["lan"]["children"][item.name]["label"]= item.name + "_game";
          Games["children"]["lan"]["children"][item.name]["name"]= item.name;
          Games["children"]["lan"]["children"][item.name]["pid"]= item.id;
          Games["children"]["lan"]["children"][item.name]["parent"]= "lanGames";
          Games["children"]["lan"]["children"][item.name]["oneGrade"]= [];
          Games["children"]["lan"]["children"][item.name]["children"]= {};
        }

        /* 情绪与社会认知下的一级脑能力 */
        if(item.pid == Games["children"]["men"]["pid"]){
          Games["children"]["men"]["oneGrade"][item.name] = {};
          Games["children"]["men"]["oneGrade"][item.name]["name"] = item.name;
          Games["children"]["men"]["oneGrade"][item.name]["id"] = item.id;
          Games["children"]["men"]["oneGrade"][item.name]["pid"] = item.pid;
          Games["children"]["men"]["oneGrade"][item.name]["games"] = [];
          Games["children"]["men"]["children"][item.name]= {};
          Games["children"]["men"]["children"][item.name]["label"]= item.name + "_game";
          Games["children"]["men"]["children"][item.name]["name"]= item.name;
          Games["children"]["men"]["children"][item.name]["pid"]= item.id;
          Games["children"]["men"]["children"][item.name]["parent"]= "menGames";
          Games["children"]["men"]["children"][item.name]["oneGrade"]= [];
          Games["children"]["men"]["children"][item.name]["children"]= {};
        }

        trainList.forEach((game)=>{
          var label;
          label = game.label.split(",");
          for(var i = 0; i < label.length; i++){
            if(item.id == label[i]){
              Games["oneGrade"][item.name]["games"].push(game);
              if(!Games["oneGrade"]["all"]["games"].includes(game)){
                //includes去重
                Games["oneGrade"]["all"]["games"].push(game);
              }
            }
            if(item.id == label[i] && item.pid == Games["children"]["cogn"]["pid"]){
              Games["children"]["cogn"]["oneGrade"][item.name]["games"].push(game);
              Games["children"]["cogn"]["children"][item.name]["oneGrade"].push(game);
              Games["children"]["cogn"]["oneGrade"]["all"]["games"].push(game);
            }
            if(item.id == label[i] && item.pid == Games["children"]["lan"]["pid"]){
              Games["children"]["lan"]["oneGrade"][item.name]["games"].push(game);
              Games["children"]["lan"]["children"][item.name]["oneGrade"].push(game);
              Games["children"]["lan"]["oneGrade"]["all"]["games"].push(game);
            }
            if(item.id == label[i] && item.pid == Games["children"]["men"]["pid"]){
              Games["children"]["men"]["oneGrade"][item.name]["games"].push(game);
              Games["children"]["men"]["children"][item.name]["oneGrade"].push(game);
              Games["children"]["men"]["oneGrade"]["all"]["games"].push(game);
            }
          }
        })
      })
      return Games;
  }

  let Ajax = {
    get: function(url, fn, token) {
      var xhr = new XMLHttpRequest();     
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Authorization','Bearer ' + token);
      xhr.onreadystatechange = function() {
        if(xhr.readyState == 4){
          if (xhr.status == 200 || xhr.status == 304) { 
            fn.call(this, xhr.responseText,xhr.status);  
          }else{
            fn.call(this, xhr.response ,xhr.status);
          }
        }
      };
      xhr.send();
    },
    post: function (url, data, fn) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");  
      xhr.onreadystatechange = function() {
        if(xhr.readyState == 4){
          if (xhr.status == 200 || xhr.status == 304) { 
            fn.call(this, xhr.responseText,xhr.status);  
          }else{
            fn.call(this, xhr.response ,xhr.status);
          }
        }
      };
      xhr.send(data);
    }
  }
  
  /* 表单post提交 */
  function postData(url,postData,fn){
    let data = objToFromData(postData);
    Ajax.post(url,data,fn)
  }
  
  /* 表单get方法 */
  function getData(url,fn,token){
    Ajax.get(url,fn,token);
  }
  
  
  /* 对象转fromdata */
  function objToFromData(obj){
    var data = "";
    for(var o in obj){
      data += o + "=" + obj[o] + "&";
    }
    return data.slice(0,-1);
  }
  
export {
  removeByValue,
  getPara,
  curDate,
  getOtherDate,
  getSelect,
  resetData,
  contains,
  addCheck,
  reverseObj,
  dateFormat,
  compareDate,
  date2Str,
  str2Date,
  formatDate,
  getAllGames,
  postData,
  getData,
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js